import { render, staticRenderFns } from "./CommunicationFeedbackPage.vue?vue&type=template&id=0e405b41&scoped=true"
import script from "./CommunicationFeedbackPage.vue?vue&type=script&lang=js"
export * from "./CommunicationFeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./CommunicationFeedbackPage.vue?vue&type=style&index=0&id=0e405b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e405b41",
  null
  
)

export default component.exports